import { LoadableAfterPaint } from '@confluence/loadable';

export const EditorAppearanceButtonNext = LoadableAfterPaint({
	loader: async () => {
		const { EditorAppearanceButtonNext } = await import(
			/* webpackChunkName: "loadable-EditorAppearanceButtonNext" */ '../src/EditorAppearanceButtonNext.tsx'
		);
		return EditorAppearanceButtonNext;
	},
});
